import { Accordion, Message } from 'semantic-ui-react'
import styled from 'styled-components'

export const Title = styled.h3`
  font-size: 1.125rem;
  margin: 0 0 0 10px;
  font-weight: normal;
  color: #1c1c1c;
`

export const StyledAccordion = styled(Accordion)`
  margin-top: 5px;
  margin-bottom: 5px;
`

export const StyledMessage = styled(Message)`
  && {
    &.message {
      &.positive.ui {
        border: 1px solid var(--wg-green);
        background-color: #f6f9f3;
      }
      &.negative.ui {
        border: 1px solid var(--wg-red);
        background-color: #f9e3e3;
      }
      padding: 0.25em 0.5em;
      h3 {
        font-size: 1em;
      }
      header {
        font-size: 0.8rem;
      }
    }
  }
`
export const StyledImageContainer = styled.div`
  width: 20px;
  margin-right: 5px;
`
export const StyledIcon = styled.div`
  svg {
    width: 16px;
    height: 16px;
  }
`

export const StyledErrorContainer = styled.div`
  color: var(--wg-red);
  background-color: #fef6f6;
  padding: 1rem;
  border: 1px solid var(--wg-red);
  border-radius: 0.25rem;
`
